export default "__VITE_ASSET__DdCq9OD6__"